import type { ProviderKernelVersionEnum } from '@dynamic-labs/sdk-api-core';
import { constants } from '@zerodev/sdk';
import type { EntryPointType } from '@zerodev/sdk/types';
import type { EntryPointVersion } from 'viem/account-abstraction';

import { ENTRY_POINT_VERSION_MAP, KERNEL_VERSION_MAP } from '../../constants';

type GetKernelVersionParams = {
  entryPoint: EntryPointType<EntryPointVersion>;
  kernelVersion: ProviderKernelVersionEnum | undefined;
};

export const getKernelVersion = ({
  kernelVersion,
  entryPoint,
}: GetKernelVersionParams) => {
  // If kernel version is explicitly provided, use it
  if (kernelVersion && kernelVersion in KERNEL_VERSION_MAP) {
    return KERNEL_VERSION_MAP[kernelVersion];
  }

  // If no kernel version provided, determine based on entry point version
  const entryPointVersion: keyof typeof ENTRY_POINT_VERSION_MAP =
    entryPoint.version;
  if (entryPointVersion in ENTRY_POINT_VERSION_MAP) {
    return ENTRY_POINT_VERSION_MAP[entryPointVersion];
  }

  // Fallback to latest version
  return constants.KERNEL_V3_3;
};
